import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, MailOpen, Search } from "lucide-react";
import { Breadcrumb, GradientPanel, PrimaryButton } from "../components/common";

const Inbox = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState("inbox");
  const [q, setQ] = useState("");

  const switchTab = (t) => {
    if (t === "parse") return navigate("/a/parse");
    setTab(t);
  };

  return (
    <div>
      <Breadcrumb items={[{ label: "Dashboard", path: "/a/dashboard" }, { label: "Inbox" }]} />
      <GradientPanel>
        <h1 className="text-2xl font-bold text-gray-900">Inbox</h1>
        <p className="text-sm text-gray-500 mt-1">View and manage document parsing jobs.</p>

        <div className="flex gap-6 mt-5">
          <div className="w-[220px] shrink-0">
            <div className="inline-flex p-1 bg-gray-100 rounded-lg">
              <button onClick={() => switchTab("inbox")} className={`px-5 py-1.5 text-sm font-medium rounded-md transition ${tab === "inbox" ? "bg-orange-500 text-white" : "text-gray-600"}`}>inbox</button>
              <button onClick={() => switchTab("parse")} className="px-5 py-1.5 text-sm font-medium rounded-md text-gray-600 hover:text-gray-800 transition">parse</button>
            </div>
            <div className="mt-4 h-[360px] border-l border-gray-100" />
          </div>

          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Search</label>
            <div className="relative max-w-xs">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search mail" className="w-full pl-9 pr-3 py-2 text-sm rounded-lg border border-gray-200 outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 transition" />
            </div>
            <div className="flex flex-col items-center justify-center py-16 text-center">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-100 flex items-center justify-center mb-4">
                <MailOpen size={28} className="text-blue-400" strokeWidth={1.6} />
              </div>
              <h3 className="text-base font-semibold text-gray-800">No messages yet</h3>
              <p className="text-sm text-gray-500 mt-2 max-w-sm">Your inbox collects incoming emails and attachments so you can classify and process them automatically.</p>
              <div className="mt-5"><PrimaryButton icon={Plus}>Set up integration</PrimaryButton></div>
            </div>
          </div>
        </div>
      </GradientPanel>
    </div>
  );
};

export default Inbox;
